export const isMarketplaceOrderEngagement = (engagement) =>
  engagement?.engagement_type === 'order' ||
  String(engagement?.preferences || '').toLowerCase().trim() === 'buy-directly';

export const getMarketplaceEngagementNotice = (engagement) => {
  if (isMarketplaceOrderEngagement(engagement)) {
    return {
      message: 'You have already placed an order for this product.',
      linkTo: '/purchase-order-list',
      linkLabel: 'View your purchase orders',
    };
  }
  return {
    message: 'You have already sent an enquiry for this product.',
    linkTo: '/buyer-rfq',
    linkLabel: 'View your RFQs',
  };
};
